import { Avatar, Tooltip } from 'antd'
import React from 'react'
import { useHistory } from 'react-router'

import { routes } from '@/routes'

import { UserHoverCard } from '../user-hover-card'
import { UserListModal, UserListModalProps } from '../users-list'

export const UserAvatarGroup: React.FC<
  {
    users: { userId: number; avatarUrl: string; email: string }[]
    totalCount: number
    showCount: number
    avatarTooltipMessage?: string
  } & UserListModalProps
> = ({ users, totalCount, showCount, avatarTooltipMessage, ...props }) => {
  const history = useHistory()

  const avatarUsers = (() => {
    if (totalCount > showCount) {
      return users.slice(0, showCount - 1).concat(Array.from({ length: 1 }))
    }
    return users
  })()

  const userListAvatar = (
    <Avatar style={{ cursor: 'pointer', backgroundColor: '#f56a00' }}>{`+${totalCount - showCount + 1}`}</Avatar>
  )

  return (
    <Avatar.Group size='small'>
      {avatarUsers.map((n) =>
        n ? (
          <UserHoverCard key={n.userId} email={n.email}>
            <Avatar
              gap={10}
              onClick={() => history.push(routes.users.page(n.userId))}
              style={{ cursor: 'pointer' }}
              src={n.avatarUrl}
            />
          </UserHoverCard>
        ) : (
          <UserListModal key='more' {...props}>
            {avatarTooltipMessage ? <Tooltip title={avatarTooltipMessage}>{userListAvatar}</Tooltip> : userListAvatar}
          </UserListModal>
        )
      )}
    </Avatar.Group>
  )
}
